import { Box, Stack } from '@mui/material';
import { ReactNode } from 'react';

import { classNames } from 'shared/lib/utils/classNames';

import { Text } from '../Text';
import cls from './DottedTextRow.module.scss';

interface DottedTextRowProps {
  title: ReactNode | string;
  className?: string;
  text?: ReactNode;
  textColor?: string;
  dataTestId?: string;
  backgroundColor?: string;
}

export const DottedTextRow = (props: DottedTextRowProps) => {
  const { className, title, text, textColor, dataTestId, backgroundColor } =
    props;

  return (
    <Stack className={cls.DottedTextRowContainer}>
      <Box className={cls.Dots} />

      <Box
        className={classNames(cls.Title, {}, [className])}
        style={{
          background: backgroundColor || 'var(--ucr-palette-background-white)',
        }}
      >
        {typeof title === 'string' ? <Text variant='t3'>{title}</Text> : title}
      </Box>

      <Box
        className={classNames(cls.Value, {}, [className])}
        style={{
          background: backgroundColor || 'var(--ucr-palette-background-white)',
        }}
      >
        <Text
          variant='t3'
          color={textColor || '#0E0E10'}
          data-testid={dataTestId}
        >
          {text}
        </Text>
      </Box>
    </Stack>
  );
};
